/**
 * @generated SignedSource<<6aa6b908484a5da17f90f81d3f53f8f1>>
 * @relayHash c162cdfbdf5bb9eb48734474012a790f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 910b9ca0dd453cef06156f9999eb599f293fe2c899a41983db58cac2d2c14788

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentPosition = "AFTER" | "APPEND" | "BEFORE" | "%future added value";
export type ConfluenceContentRestrictionStateInput = "EDIT_RESTRICTED" | "OPEN" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceMoveRequestInput = {
  position: ConfluenceContentPosition;
  targetId: string;
};
export type PageRestrictionsInput = {
  includeInvites?: boolean | null;
  read?: PageRestrictionInput | null;
  update?: PageRestrictionInput | null;
};
export type PageRestrictionInput = {
  group?: ReadonlyArray<PageGroupRestrictionInput> | null;
  user?: ReadonlyArray<PageUserRestrictionInput> | null;
};
export type PageGroupRestrictionInput = {
  id?: string | null;
  name: string;
};
export type PageUserRestrictionInput = {
  id: string;
};
export type ConfluenceContentPermissionsInput = {
  edit?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null> | null;
  view?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null> | null;
};
export type ConfluenceContentPermissionPrincipalInput = {
  id: string;
  type: ConfluencePrincipalType;
};
export type usePublishUpdatePageMutation$variables = {
  cloudId: string;
  content: string;
  contentId: string;
  message?: string | null;
  moveRequest?: ConfluenceMoveRequestInput | null;
  ncsStepVersion: string;
  permissions?: ConfluenceContentPermissionsInput | null;
  restrictionState?: ConfluenceContentRestrictionStateInput | null;
  restrictions?: PageRestrictionsInput | null;
  schedulePublishDate?: string | null;
  spaceKey: string;
  suppressNotifyWatchers?: boolean | null;
  title: string;
  version: number;
};
export type usePublishUpdatePageMutation$data = {
  readonly confluence_updatePage: {
    readonly content: {
      readonly space: {
        readonly name: string | null;
      } | null;
      readonly status: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type usePublishUpdatePageMutation = {
  response: usePublishUpdatePageMutation$data;
  variables: usePublishUpdatePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "moveRequest"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ncsStepVersion"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictionState"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schedulePublishDate"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suppressNotifyWatchers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v14 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentBody",
            "variableName": "content"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "minorEdit",
            "variableName": "suppressNotifyWatchers"
          },
          {
            "kind": "Variable",
            "name": "moveRequest",
            "variableName": "moveRequest"
          },
          {
            "kind": "Variable",
            "name": "ncsStepVersion",
            "variableName": "ncsStepVersion"
          },
          {
            "kind": "Variable",
            "name": "permissions",
            "variableName": "permissions"
          },
          {
            "kind": "Variable",
            "name": "restrictionState",
            "variableName": "restrictionState"
          },
          {
            "kind": "Variable",
            "name": "restrictions",
            "variableName": "restrictions"
          },
          {
            "kind": "Variable",
            "name": "schedulePublishDate",
            "variableName": "schedulePublishDate"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          },
          {
            "kind": "Variable",
            "name": "versionMessage",
            "variableName": "message"
          }
        ],
        "kind": "ObjectValue",
        "name": "confluenceContentInput"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "draft"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "success"
},
v16 = {
  "kind": "ScalarField",
  "name": "status"
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = {
  "kind": "ScalarField",
  "name": "message"
},
v19 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v20 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePublishUpdatePageMutation",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "ConfluenceUpdatePagePayload",
        "kind": "LinkedField",
        "name": "confluence_updatePage",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v17/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePublishUpdatePageMutation",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "ConfluenceUpdatePagePayload",
        "kind": "LinkedField",
        "name": "confluence_updatePage",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v19/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c162cdfbdf5bb9eb48734474012a790f",
    "id": "910b9ca0dd453cef06156f9999eb599f293fe2c899a41983db58cac2d2c14788",
    "metadata": {},
    "name": "usePublishUpdatePageMutation",
    "operationKind": "mutation",
    "text": "mutation usePublishUpdatePageMutation($contentId:ID!,$content:String!,$message:String,$spaceKey:String!,$suppressNotifyWatchers:Boolean,$ncsStepVersion:String!,$title:String!,$version:Int!,$schedulePublishDate:String,$moveRequest:ConfluenceMoveRequestInput,$restrictions:PageRestrictionsInput,$cloudId:ID!,$restrictionState:ConfluenceContentRestrictionStateInput,$permissions:ConfluenceContentPermissionsInput){confluence_updatePage(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,moveRequest:$moveRequest,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,spaceKey:$spaceKey,title:$title,version:$version,versionMessage:$message,restrictionState:$restrictionState,permissions:$permissions},status:\"draft\"}){success,content{status,space{name,id},id},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "ceee81a84b894b5ca43c4dc1de97ec33";

export default node;
